<template>
  <div id="statboard">
    <h1 style="margin: 20px 0 5px 15px">Statistics</h1>
    <div class="statsCommandbar flexLeftRow">
      <ConnectionButton :connectionCount="2" style="margin-right: 7px" />
      <BaseButton :icon="RotateCw" :text="'Reload board'" />
      <BaseButton :icon="Plus" :text="'Add to board'" />
    </div>
    <draggable
      v-model="boxes"
      id="statistics"
      item-key="id"
      handle=".vgrip"
      ghost-class="drag-ghost"
      :options="{ delay: 0, delayOnTouchOnly: true }"
    >
      <template v-slot:item="{ element, index }">
        <div
          class="statBox"
          :key="index"
          v-if="!this.graphIsLoading.includes(element.id)"
        >
          <Chart
            :chartType="element.type"
            :title="element.title"
            :connections="element.connections"
            :data="element.data"
            @reload="reloadWidget(element, index)"
          />
          <!-- <h3>Connections</h3> -->
          <div class="flexLeftRow statsEdit">
            <Select
              size="small"
              :title="'Select math'"
              :items="element.connections[0].math"
              :selected="element.connections[0].math[0]"
              @selectedItem="changeWidget(element, index, 'math', $event)"
            />
            <h3 style="padding: 0 10px">of col:</h3>
            <Select
              size="small"
              :title="'Select column'"
              :items="element.connections[0].cols"
              :selected="element.connections[0].x_col"
              @selectedItem="changeWidget(element, index, 'x_col', $event)"
            />
            <h3 style="padding: 0 10px">per col:</h3>
            <Select
              size="small"
              :title="'Select column'"
              :items="element.connections[0].cols"
              :selected="element.connections[0].y_col"
              @selectedItem="changeWidget(element, index, 'y_col', $event)"
            />
          </div>
        </div>
        <div v-else class="statBox" style="height: 413px">
          <div class="flexSpaceBetweenRow" style="padding: 10px">
            <div class="flexLeftRow">
              <GripVertical size="15" color="#808080" class="vgrip" />
              <LoadingText width="200px" style="margin-left: 10px" />
            </div>
            <!-- <Ellipsis size="15" color="#808080" /> -->
            <BaseButton :icon="RotateCw" @click="reload()" />
          </div>
          <LoadingText width="500px" height="300px" style="margin-left: 35px" />
          <div class="flexLeftRow statsEdit">
            <LoadingText width="150px" />
            <h3 style="padding: 0 10px">of col:</h3>
            <LoadingText width="150px" />
            <h3 style="padding: 0 10px">per col:</h3>
            <LoadingText width="150px" />
          </div>
        </div>
      </template>
    </draggable>
  </div>
</template>

<script>
import axios from "axios";
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
import Chart from "../../../../components/charts/Chart.vue";
import draggable from "vuedraggable";
import ConnectionButton from "../../../../components/buttons/ConnectionButton.vue";
import BaseButton from "../../../../components/buttons/BaseButton.vue";
import { RotateCw, Plus, GripVertical } from "lucide-vue-next";
import Select from "../../../../components/inputs/Select.vue";
import LoadingText from "../../../../components/utilities/LoadingText.vue";

export default {
  name: "Statistics",
  components: {
    GripVertical,
    Chart,
    draggable,
    ConnectionButton,
    BaseButton,
    Select,
    LoadingText,
  },
  mounted() {
    this.boxes.forEach((box, index) => {
      this.reloadWidget(box, index);
    });
  },
  methods: {
    changeWidget(element, index, type, $event) {
      console.log($event);
      if (type === "x_col") {
        this.boxes[index].connections[0].x_col = $event;
      } else if (type === "y_col") {
        this.boxes[index].connections[0].y_col = $event;
      } else if (type === "math") {
        this.boxes[index].connections[0].math = [$event];
      }
      // this.boxes[index].connections[0].math = $event;
      this.reloadWidget(element, index);
    },
    async reloadWidget(widget, index) {
      console.log(widget);
      this.graphIsLoading.push(widget.id);
      const options = {
        method: "POST",
        url: "https://moonarchio--moonarch-backend-tools.modal.run/charts",
        "headers": {
          "Authorization":
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicG9ydGFsIiwic3Vic2NyaXB0aW9uX3RpZXIiOiJhZG1pbiIsImV4cGlyeV9kYXRlIjoiMjAyNi0wNC0xMFQxNjoyODo0MS44ODc3NDYrMDA6MDAiLCJleHAiOjE3NzU4Mzg1MjF9.A5z62qNGvjQQb-0-rblMyFZ7VBbW9LDa8vqV-NHyvKI",
        },
        data: {
          user_id: "h3egui23yegu23yeg23uye23ueg23yueg2ug3dvbf23uyrfv23u",
          chart_type: widget.type,
          integration: [
            {
              type: widget.connections[0].type,
              item: widget.connections[0].item,
              structure: {
                x_column: widget.connections[0].x_col.toLowerCase(),
                y_column: widget.connections[0].y_col.toLowerCase(),
                math_function: widget.connections[0].math[0].toLowerCase(),
              },
            },
          ],
          data_type: "time series",
        },
      };
      console.log(options);
      try {
        let response = await axios.request(options);
        this.graphIsLoading = this.graphIsLoading.filter(
          (id) => id !== widget.id
        );
        console.log("done");
        console.log(response.data);

        this.boxes[index].data = response.data.data;
        // return response.data.results;
      } catch (error) {
        this.graphIsLoading = this.graphIsLoading.filter(
          (id) => id !== widget.id
        );
        console.log(error);
      }
    },
  },
  setup() {
    return {};
  },
  data() {
    const list_of_cols = [
      "name",
      "current_revenue",
      "total_revenue",
      "total_addressable_market",
      "current_funding",
      "industry",
      "team_members",
      "region",
      "year_founded",
      "headcount",
    ];
    return {
      RotateCw,
      Plus,
      graphIsLoading: [],
      boxes: [
        {
          id: 1,
          title: "Total Inbound per Year",
          type: "BarChart",
          connections: [
            {
              type: "Sheets",
              item: "Drift Capital Deals",
              pages: ["name of sheet", "other sheet"],
              x_col: "total_revenue",
              y_col: "year_founded",
              cols: list_of_cols,
              math: ["Sum", "Average"],
            },
          ],
          data: [],
        },
        {
          id: 4,
          title: "Number of Companies per Industry",
          type: "PieChart",
          connections: [
            {
              type: "Sheets",
              item: "Drift Capital Deals",
              pages: ["name of sheet", "other sheet"],
              x_col: "industry",
              y_col: "",
              cols: list_of_cols,
              math: ["Count", "Sum", "Average"],
            },
          ],
          data: [],
        },
        {
          id: 3,
          title: "Revenue per Country",
          type: "MapChart",
          connections: [
            {
              type: "Sheets",
              item: "Drift Capital Deals",
              pages: ["name of sheet", "other sheet"],
              x_col: "total_revenue",
              y_col: "region",
              cols: list_of_cols,
              math: ["Sum", "Average"],
            },
          ],
          data: [],
        },
        {
          id: 2,
          title: "Revenue per Year",
          type: "LineChart",
          connections: [
            {
              type: "Sheets",
              item: "Drift Capital Deals",
              pages: ["name of sheet", "other sheet"],
              x_col: "total_revenue",
              y_col: "year_founded",
              cols: list_of_cols,
              math: ["Sum", "Average"],
            },
          ],
          data: [],
        },
      ],
    };
  },
};
</script>

<style>
#statboard {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 51px);
}
#statistics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: fit-content;
  padding: 5px 0;
}
.statBox {
  width: calc(50% - 20px);
  border: thin solid lightgray;
  border-radius: 7px;
  margin: 5px;
  height: calc(50% - 15px);
}
.drag-ghost {
  background-color: #f0f0f0;
  border: thin dashed #721cff;
  color: transparent;
}
.statsCommandbar {
  width: 100%;
  height: 50px;
  padding: 5px 12px;
}
.statsEdit {
  padding: 10px;
  margin-top: 20px;
}
</style>
